import Logo from './';
import styles from './headerTile.style';

const HeaderTile = ({ classes, type }) => (
  <div className={classes.headerTile}>
    <Logo className={classes.headerLogo} type={type} />
  </div>
);

export default withStyles(styles)(HeaderTile);
